module.exports = {
  newtest: 'test',
  test01: 'test',
  test02: 'test',
  staging: 'st',
  production: 'prod',
}
